<template>
  <div class="">


    <div class="col-12">
      <div class="row">
        <div class="col-lg-4">
          <filter-status v-model="productStatus" class="my-2"/>
        </div>

        <div class="col-lg-4">
          <filter-feature1 @features="setProductFeature" class="my-2"/>
        </div>
      </div>
    </div>

    <m-product-wrapper :product-status="productStatus"
                       :product-features="productFeatures"
                       :dashboard-product="true">
      <template v-slot="{products,pagination,changePageFunction}">

        <table class="table table-striped ">
          <thead>
          <tr>
            <th scope="col" v-t="`product.single.dashboard.table.product_name`"></th>
            <th scope="col" v-t="`product.single.dashboard.table.product_type_title`"></th>
            <th scope="col" v-t="`product.single.dashboard.table.product_order`"></th>
            <th scope="col" v-t="`product.single.dashboard.table.action`"></th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="product in products">
            <th scope="row">{{ product.name }}</th>
            <td>{{ translateProductType(product.is_digital) }}</td>
            <td>{{ product.order }}</td>
            <td>

              <m-a target="_blank" class="text-dark "
                   :href="{ name: 'EditProduct', params: { slug: product.raw_link } }">
                  <span class="h4" data-toggle="tooltip" title="ویرایش">
                      <i class="bi bi-pencil h4"></i>
                  </span>
              </m-a>

              <m-copy1 :item-id="product.id" class="h4 " item-type="product"/>

              <m-delete1 icon-name="trash" :item-id="product.id" class="h4 " item-type="product"/>


            </td>
          </tr>
          </tbody>
        </table>

        <div class="row pt-3 mt-3">
          <m-paginate1 :meta="pagination" :on-change-page="changePageFunction"/>
        </div>

      </template>
    </m-product-wrapper>
  </div>
</template>

<script>
import mCopy1 from "../../../../Tool/Copy/Copy1.vue";
import mProductWrapper from "../../../../Wrappers/ProductWrapper";
import mPaginate1 from "../../../../Pagination/Paginate1";
import mA from '../../../../Tags/A.vue'
import FilterStatus from "../../../Filter/FilterStatus.vue";
import FilterFeature1 from "../../../../Feature/Filter/FilterFeature1.vue";
import mDelete1 from "../../../../Tool/Delete/Delete1.vue";

export default {
  name: "DashboardProduct300",
  components: {FilterStatus, mPaginate1, mCopy1, mProductWrapper, mA, FilterFeature1, mDelete1},
  data() {
    return {
      productStatus: '',
      productFeatures: null,
    }
  },
  methods: {
    translateProductType(productType) {
      if (productType == 1) {
        return this.$t(`product.single.dashboard.product_types.types.digital`)
      }

      return this.$t(`product.single.dashboard.product_types.types.physical`)


    },
    setProductFeature(features) {
      this.productFeatures = features
    },
  }
}
</script>


<style scoped>

</style>